import { render, staticRenderFns } from "./PeopleTaskBarCharttool.vue?vue&type=template&id=5271bd2f"
import script from "./PeopleTaskBarCharttool.vue?vue&type=script&lang=js"
export * from "./PeopleTaskBarCharttool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports